import React, { useMemo } from 'react';
import { useEsito, useInfoAggiuntivaData } from 'features/sport/hooks';

import { ScommesseLeafItemProps } from './types';
import { decodeEsitoValue } from '.';

export const EsitoCell = ({ itemKey, infoAggiuntivaKey }: ScommesseLeafItemProps) => {
  const esito = useEsito(itemKey);
  const { quota, isActive: isEsitoActive } = esito ?? {};

  const infoAggData = useInfoAggiuntivaData(infoAggiuntivaKey);
  const { isActive: isInfoAggActive } = infoAggData ?? {};

  const value = useMemo(() => {
    return isEsitoActive && isInfoAggActive ? quota : '-';
  }, [isEsitoActive, isInfoAggActive, quota]);

  return <React.Fragment key={`EsitoCell-${value}`}>{decodeEsitoValue(value, false)}</React.Fragment>;
};
